import Vue from 'vue'
import VueResource from 'vue-resource'
import AuthService from '../service/auth.js'

Vue.use(VueResource)
Vue.http.options.root = process.env.URL_API
Vue.http.interceptors.push((request, next) => {
  if (AuthService.getToken()) {
    request.headers.set('X-Token', 'Bearer ' + AuthService.getToken())
  }
  next()
})



// WEBPACK FOOTER //
// ./src/core/http.js